import type { DrawerConfig } from '../configuration';
import type {
  FlowCreationData,
  FlowCreationDrawer as FlowCreationDrawerProps,
} from '../types';
import { FlowCreationDrawer } from '.';
import { FlowCreationDrawerBody } from './FlowCreationDrawerBody';
import { FlowCreationDrawerHeader } from './FlowCreationDrawerHeader';
import { FlowCreationDrawerOverflowCard } from './FlowCreationDrawerOverflowCard';

export const flowCreationConfig = {
  drawer: FlowCreationDrawer,
  body: FlowCreationDrawerBody,
  header: FlowCreationDrawerHeader,
  overflowCard: FlowCreationDrawerOverflowCard,
  allowMultipleInstance: false,
  resetOnCreate: false,
  getId: () => 'flowCreation',
  shouldConfirmOnClose: (props: FlowCreationDrawerProps) => {
    const { data } = props;

    return data.view !== 'empty';
  },
  onClose: () => {},
} satisfies DrawerConfig<FlowCreationDrawerProps, FlowCreationData>;
